// extracted by mini-css-extract-plugin
module.exports = {"img":"CloudPopUpImagePicker_img__2zZZe","container":"CloudPopUpImagePicker_container__2plbT"};